


































































import { Component, Prop } from 'vue-property-decorator';
import SaascadaVueFieldGroup from '@/components/Shared/SaascadaVueForm';
import { DepositAccountSettingsModule } from '@/store/Accounts/DepositAccountSettingsModule';
import AccountGeneralPayeeSettings from '@/models/Accounts/LendingAccounts/Ledgers/Settings/GeneralPayee/AccountGeneralPayeeSettings';
import { VuetifyConfirmObject } from 'vuetify-confirm';
import PermissionUtils from '@/lib/permissionUtils';

@Component({ name: 'AccountGeneralPayeeSettingsRead' })
export default class extends SaascadaVueFieldGroup {

    PermissionUtils = PermissionUtils;

    @Prop({required: true })
    settings: AccountGeneralPayeeSettings;

    async deleteGeneralPayeeSettings() {
        const options: VuetifyConfirmObject = {
            buttonTrueText: "Delete",
            buttonFalseText: "Close",
            buttonTrueColor: "primary",
            buttonFalseColor: "primary",
        }
        const result = await this.$confirm('Are you sure you want to delete the overridden account settings?', options);
        if (result) {
            await DepositAccountSettingsModule.deleteGeneralPayeeSettings();
        }
    }


}
